import { Box, IconButton, Tooltip, TypographyProps } from '@mui/material'
import React from 'react'
import CustomText from './CustomText'

interface Props extends TypographyProps {
  title: string;
  text: string;
  fontWeight?: number;
  onClick?: () => void;
}

export default function TitleText({ title, text, onClick, ...props }: Props) {
  return (
    <Tooltip title={title}>
      <Box
        component="span"
        onClick={onClick}
        sx={{ cursor: onClick ? 'pointer' : 'default', display: 'block' }}
      >
        <CustomText {...props} text={text} />
      </Box>
    </Tooltip>
  )
}
